import { render } from "./TranslationModal.vue?vue&type=template&id=0704b255&scoped=true"
import script from "./TranslationModal.vue?vue&type=script&lang=ts"
export * from "./TranslationModal.vue?vue&type=script&lang=ts"

import "./TranslationModal.vue?vue&type=style&index=0&id=0704b255&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0704b255"

export default script